export const PRIVACY_TECH_CATEGORIES = [
  {
    title: "Privacy Management Platforms",
    description: "Core privacy orchestration: consent, DSAR, ROPA, DPIA, vendor privacy.",
    rows: [
      { vendor: "OneTrust", strengths: "Comprehensive, market leader", dpdpaControls: "CON, DPR, DPG, SDF", estimatedCost: "₹50L-2Cr/yr" },
      { vendor: "TrustArc", strengths: "Enterprise privacy ops", dpdpaControls: "CON, DPR, ACC", estimatedCost: "₹40L-1.5Cr/yr" },
      { vendor: "Securiti", strengths: "AI-powered, data intelligence", dpdpaControls: "CON, DPR, DPG", estimatedCost: "₹30L-1Cr/yr" },
      { vendor: "Forcepoint", strengths: "Discovery + privacy", dpdpaControls: "DPR, DPG", estimatedCost: "₹40L-1.5Cr/yr" },
    ],
  },
  {
    title: "Consent Management",
    description: "Notice, consent capture, withdrawal, and audit trails.",
    rows: [
      { vendor: "OneTrust CMP", strengths: "Enterprise consent", dpdpaControls: "CON-01..CON-12", estimatedCost: "₹20L-50L/yr" },
      { vendor: "Cookiebot", strengths: "Cookie-focused", dpdpaControls: "CON-01, CON-03", estimatedCost: "₹5L-15L/yr" },
      { vendor: "Osano", strengths: "Easy implementation", dpdpaControls: "CON-01..CON-07", estimatedCost: "₹10L-30L/yr" },
      { vendor: "Usercentrics", strengths: "European market focus", dpdpaControls: "CON-01..CON-08", estimatedCost: "₹10L-25L/yr" },
    ],
  },
  {
    title: "Data Discovery & Classification",
    description: "Discover, classify and map personal data across structured and unstructured stores.",
    rows: [
      { vendor: "Forcepoint", strengths: "ML-based discovery", dpdpaControls: "DPG-03, DPG-06, CBT-02", estimatedCost: "₹40L-1.5Cr/yr" },
      { vendor: "Securiti", strengths: "Sensitive data intel", dpdpaControls: "DPG-03, DPR-01, DPR-03", estimatedCost: "₹30L-1Cr/yr" },
      { vendor: "Varonis", strengths: "Unstructured data", dpdpaControls: "SEC-04, SEC-06", estimatedCost: "₹35L-1Cr/yr" },
      { vendor: "Microsoft Purview", strengths: "Azure-native", dpdpaControls: "DPG-03, SEC-08", estimatedCost: "Included in E5" },
    ],
  },
  {
    title: "DSAR Automation",
    description: "DSAR intake, identity verification, workflow, and fulfillment automation.",
    rows: [
      { vendor: "OneTrust", strengths: "Workflow + fulfillment", dpdpaControls: "DPR-01..DPR-10", estimatedCost: "₹25L-60L/yr" },
      { vendor: "Forcepoint", strengths: "Discovery + DSAR", dpdpaControls: "DPR-01, DPR-03", estimatedCost: "₹35L-1Cr/yr" },
      { vendor: "Transcend", strengths: "Automated data access", dpdpaControls: "DPR-01..DPR-06", estimatedCost: "₹20L-50L/yr" },
      { vendor: "DataGrail", strengths: "Privacy ops automation", dpdpaControls: "DPR-01..DPR-08", estimatedCost: "₹15L-40L/yr" },
    ],
  },
  {
    title: "Data Masking & Pseudonymization",
    description: "Reduce risk while enabling analytics and testing.",
    rows: [
      { vendor: "Delphix", strengths: "Dynamic data platform", dpdpaControls: "SEC-05, DPG-03", estimatedCost: "₹50L-2Cr/yr" },
      { vendor: "Protegrity", strengths: "Enterprise protection", dpdpaControls: "SEC-05, SEC-02", estimatedCost: "₹40L-1.5Cr/yr" },
      { vendor: "EDB", strengths: "Masking + quality", dpdpaControls: "SEC-05, DPG-04", estimatedCost: "₹35L-1.2Cr/yr" },
      { vendor: "K2View", strengths: "Entity-based fabric", dpdpaControls: "SEC-05", estimatedCost: "₹30L-1Cr/yr" },
    ],
  },
  {
    title: "Encryption & Key Management",
    description: "Encrypt data at rest/in transit and manage keys with HSM/KMS.",
    rows: [
      { vendor: "Thales CipherTrust", strengths: "Key mgmt + encryption", dpdpaControls: "SEC-02, SEC-03, SEC-09", estimatedCost: "₹40L-1.5Cr/yr" },
      { vendor: "Entrust", strengths: "HSM + KeyControl", dpdpaControls: "SEC-02, SEC-03", estimatedCost: "₹35L-1.2Cr/yr" },
      { vendor: "Utimaco", strengths: "Secrets + keys", dpdpaControls: "SEC-02, SEC-04", estimatedCost: "₹15L-50L/yr" },
      { vendor: "Cloud KMS", strengths: "Cloud-native", dpdpaControls: "SEC-02, SEC-03", estimatedCost: "Pay-per-use" },
    ],
  },
  {
    title: "Data Loss Prevention",
    description: "Prevent unauthorized exfiltration across endpoints, email, and cloud.",
    rows: [
      { vendor: "Forcepoint DLP", strengths: "User-centric", dpdpaControls: "SEC-08, BRH-03", estimatedCost: "₹35L-1.2Cr/yr" },
      { vendor: "Netskope", strengths: "Cloud DLP", dpdpaControls: "SEC-08, CBT-06", estimatedCost: "₹30L-1Cr/yr" },
    ],
  },
  {
    title: "Age Verification",
    description: "Age gating and verifiable parental consent mechanisms.",
    rows: [
      { vendor: "Yoti", strengths: "Digital ID + age", dpdpaControls: "CHD-01, CHD-04, CHD-06", estimatedCost: "Per transaction" },
      { vendor: "Jumio", strengths: "AI-powered ID", dpdpaControls: "CHD-04, CHD-06", estimatedCost: "Per transaction" },
      { vendor: "Onfido", strengths: "Identity verification", dpdpaControls: "CHD-04, CHD-06", estimatedCost: "Per transaction" },
      { vendor: "VerifyMy", strengths: "Age verification", dpdpaControls: "CHD-04", estimatedCost: "Per transaction" },
    ],
  },
];

export const RECOMMENDED_STACKS = [
  {
    size: "Enterprise (>5000 employees, likely SDF)",
    bullets: [
      "Privacy Management: OneTrust or TrustArc",
      "Data Discovery: Forcepoint + Varonis",
      "Consent Management: OneTrust CMP",
      "DSAR Automation: OneTrust or Securiti",
      "Data Masking: Delphix + Protegrity",
      "Encryption/KMS: Thales CipherTrust + Cloud KMS",
      "DLP: Symantec DLP + Microsoft Purview",
      "Age Verification: Yoti or Jumio",
      "GRC: ServiceNow GRC or Archer",
      "SIEM: Splunk + SOAR",
    ],
    investment: "₹5-15 Cr annually",
    timeline: "12-18 months",
  },
  {
    size: "Mid-Market (500-5000 employees)",
    bullets: [
      "Privacy Management: Securiti or OneTrust Essentials",
      "Data Discovery: Securiti or Microsoft Purview",
      "Consent Management: Osano or Cookiebot",
      "DSAR Automation: Securiti or DataGrail",
      "Encryption/KMS: Cloud-native (AWS/Azure/GCP)",
      "DLP: Microsoft Purview or Forcepoint",
      "Age Verification: VerifyMy or Yoti",
      "GRC: ServiceNow or LogicGate",
      "SIEM: Microsoft Sentinel",
    ],
    investment: "₹1-5 Cr annually",
    timeline: "6-12 months",
  },
  {
    size: "SMB (<500 employees)",
    bullets: [
      "Privacy Management: Osano or WireWheel",
      "Data Discovery: Microsoft Purview (if M365)",
      "Consent Management: Cookiebot or Osano",
      "DSAR Automation: Manual workflow or Mine",
      "Encryption/KMS: Cloud-native",
      "DLP: Microsoft 365 DLP",
      "Age Verification: Self-declaration + basic verification",
      "GRC: Vanta or Drata",
      "SIEM: Cloud-native SIEM",
    ],
    investment: "₹20L-1Cr annually",
    timeline: "3-6 months",
  },
];
